export default __webpack_public_path__ + "static/media/dimension-logo-dark.c68d731f.svg";